import AssertionError from "./AssertionError.js";
export function assertIsDefined(val) {
  if (val === undefined || val === null) {
    throw new AssertionError("Expected 'val' to be defined, but received ".concat(val));
  }
}
export default assertIsDefined;
//# sourceMappingURL=assertIsDefined.js.map